import { Payment } from '@/types/api/payment';
import { authenticatedClient } from '@/utils/shared/axios';

export default {
  get: async (paymentId: string): Promise<Payment> => {
    const response = await authenticatedClient.get(`/payments/${paymentId}`);
    return response.data;
  },

  cancel: async (paymentId: string): Promise<void> => {
    await authenticatedClient.post(`/payments/${paymentId}/cancel`);
  },
};
